import {
  Button,
  Modal,
  ModalClose,
  ModalContent,
  ModalFooter,
  ModalHeading,
} from '@idexx-laboratories/spot-react';
import classNames from 'classnames';
import React, { useCallback, useEffect, useRef } from 'react';
import { GlobalModalProps } from '../../types/global-modal-types';
import './ModalOkCancel.scss';

const ModalOkCancel = (props: GlobalModalProps): React.JSX.Element => {
  const {
    id,
    className,
    children,
    okCaption,
    cancelCaption,
    header,
    show,
    onCancel,
    onOk,
    onExit,
    exitOkAction,
    onClickOutside,
    okDisabled,
    disabled,
    'data-testid': dataTestId,
    customFooter,
    wide,
  } = props;

  const cancelClickedRef = useRef<boolean>(false);

  useEffect(() => {
    if (show) {
      cancelClickedRef.current = false;
    }
  }, [show]);

  const doExit = useCallback(() => {
    if (exitOkAction === true) onOk();
    else if (exitOkAction === false) onCancel?.();
    else if (!cancelClickedRef.current) onExit?.();
  }, [exitOkAction, onOk, onCancel, onExit]);

  const doCancel = useCallback(() => {
    onCancel?.();
    cancelClickedRef.current = true;
  }, [onCancel]);

  return (
    <Modal
      id={id}
      className={className}
      style={wide ? { maxWidth: '90%' } : {}}
      isOpen={show}
      onOpenChange={() => show && doExit()}
      closeOnOverlayClick={!!onClickOutside}
      closeOnEscape
      aria-describedby={undefined}
    >
      <ModalHeading title={header} />
      <ModalContent>{children}</ModalContent>
      <ModalFooter
        className={classNames({ 'hide-cancel-button': !cancelCaption })}
        cancelLink={{ text: cancelCaption, onClick: doCancel }}
      >
        {customFooter || (
          <Button
            role='modal-ok-button'
            onClick={onOk}
            disabled={okDisabled || disabled}
            data-testid={`${dataTestId}-ok-btn`}
          >
            {okCaption}
          </Button>
        )}
      </ModalFooter>
      <ModalClose />
    </Modal>
  );
};

export default ModalOkCancel;
